import { FilterValues } from 'application/api'
import { URL_PARSE_OPTIONS, URL_STRINGIFY_OPTIONS } from 'application/configuration'
import { appendUrl } from 'lib/append-url'

export const createUrl = (url: string, filter?: FilterValues | null) => {
  if (filter) {
    return appendUrl({
      url: url ? url : document.location.pathname,
      parseOptions: URL_PARSE_OPTIONS,
      stringifyOptions: URL_STRINGIFY_OPTIONS,
      data: filter
    })
  } else {
    return url ? url : document.location.pathname
  }
}
